import { EPlaybackState, IPlayerState } from 'types/common';

export const INITIAL_STATE: IPlayerState = {
  canPlay: false,
  isLoading: true,
  isError: false,
  isAutoplayError: false,
  isPaused: false,
  isPlaying: false,
  isRestarted: false,
  isStalled: false,
  isWaiting: false,
  isDestroyed: false,
  videoPlaybackState: EPlaybackState.IDLE,

  startedPlaying: false,
};
